import React from 'react';

const CustomTooltip = ({ active, payload, total, totalLabel = '', label = '', valueLabel = '', unit = '' }) => {
    if (active && payload) {
      const calculatePart = () => {
        const part = (payload[0].value / total) * 100;
        return part.toFixed(1);
      }

      return (
        <div className="chart__tooltip">
          <p className="chart__tooltip-label chart__tooltip-label--heading">{label}</p>
          <p className="chart__tooltip-label">{valueLabel} {payload[0].value.toLocaleString('sv')} {unit}</p>
          {total &&
            <p className="chart__tooltip-label">{totalLabel} {calculatePart()}%</p>
          
          }
        </div>
      );
    }
  
    return null;
};

export default CustomTooltip;